import { render } from "./_Index.vue?vue&type=template&id=a06c3502&scoped=true"
import script from "./_Index.vue?vue&type=script&lang=ts"
export * from "./_Index.vue?vue&type=script&lang=ts"

import "./_Index.vue?vue&type=style&index=0&id=a06c3502&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a06c3502"

export default script